import { render, staticRenderFns } from "./WorkspaceNavigationDrawer.vue?vue&type=template&id=d90d97a0&lang=pug"
import script from "./WorkspaceNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./WorkspaceNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports